import { configureStore } from "@reduxjs/toolkit";
import createSagaMiddleware from "redux-saga";
import { mapSliceReducer } from "../redux/app/map/map-slice";
import { rootSaga } from "../saga/rootSaga";
import { affiliateReducer } from "./app/affiliate/affiliate-slice";
import { authReducer } from "./app/auth/auth-slice";
import { bookingSliceReducer } from "./app/booking/booking-slice";
import { companyReducer } from "./app/company/company-slice";
import { creditCardSliceReducer } from "./app/creditcard/creditcard-slice";
import { eventSliceReducer } from "./app/event/event-slice";
import { passengerSliceReducer } from "./app/passenger/passenger";
import { regionSliceReducer } from "./app/regions/region-slice";
import { vehicleReducer } from "./app/vehicle/vehicle-slice";
import { settingSliceReducer } from "./app/setttings/setting-slice";
import { docketReducer } from "./app/docket/docket-slice";
import { invoiceRecordSliceReducer } from "./app/invoiceRecord/invoiceRecord-slice";
import { docsSliceReducer } from "./app/apidocs/apidocs-slice";

const sagaMiddleware = createSagaMiddleware();

const middleware = [sagaMiddleware];

const store = configureStore({
  reducer: {
    map: mapSliceReducer,
    booking: bookingSliceReducer,
    vehicle: vehicleReducer,
    passenger: passengerSliceReducer,
    auth: authReducer,
    company: companyReducer,
    region: regionSliceReducer,
    event: eventSliceReducer,
    affiliate: affiliateReducer,
    creditcard: creditCardSliceReducer,
    settings: settingSliceReducer,
    docket: docketReducer,
    invoicerecord: invoiceRecordSliceReducer,
    apidocs:docsSliceReducer
  },
  middleware,
});

sagaMiddleware.run(rootSaga);

export default store;
